import React from "react"
import SnakeBlock from "../SnakeBlock"
import ConnectorBlock from "../ConnectorBlock"
import SearchBar from "../SearchBar"
import EmptyBlock from "../EmptyBlock"
import { reverseArr } from "../../utils/reverseArr"

const WebGameContainer = ({
    head,
    isMobile,
    check,
    tail,
    gameStatus,
    blocksFwd,
    blocksBck,
    direction,
    setDirection,
    guessStatus,
    setShowGoBack,
    screenshotReference,
    usedIds,
    triggerHint
    }) => {

    const createBlocksWeb = (b, fwdOrBck) => {
        if (b.length === 0) {
            return null
        }
        return b.map((block, idx) => (
            <React.Fragment key={idx}>
                <SnakeBlock key={block.id} info={block} showGoBack={() => setShowGoBack(idx, fwdOrBck)} guessStatus={guessStatus} />
                <ConnectorBlock isMobile={isMobile} height={50} color={'black'} key={idx} />
            </React.Fragment>
        ));
    }

    const currentSearchType = () => {
        let final
        if (direction === 'fwd' && blocksFwd.length === 0) {
            final = head.type
        }
        else if (direction === 'bck' && blocksBck.length === 0) {
            final = tail.type
        }
        else if (direction === 'fwd') {
            final = blocksFwd[blocksFwd.length - 1].type
        }
        else {
            final = blocksBck[blocksBck.length - 1].type
        }
        if (final === 'MEDIA') {
            return 'ACTOR'
        }
        else {
            return 'MEDIA'
        }
    }

    const flip = () => {
        let newDirection = "bck"
        if (direction === "bck") {
            newDirection = "fwd"
        }
        setDirection(newDirection)
    }

    return (
        <div className="game-container" ref={screenshotReference} style={{height:'100%'}}>
            <div className="scroll-container">
                <div className="scroll-content">
                    <SnakeBlock info={direction === 'fwd' ? head : tail} showGoBack={() => setShowGoBack(-1)} />
                    <ConnectorBlock isMobile={isMobile} height={50} color={'black'} />
                    {createBlocksWeb(direction === 'fwd' ? blocksFwd : blocksBck, direction === 'fwd' ? 'fwd' : 'bck')}
                    {gameStatus === 'in progress' &&(
                        <>
                            <EmptyBlock media={currentSearchType()}/>
                            <ConnectorBlock isMobile={isMobile} height={50} color={'black'} active />
                        </>
                    )}
                    {createBlocksWeb(direction !== 'fwd' ? reverseArr(blocksFwd) : reverseArr(blocksBck), direction !== 'fwd' ? 'fwd' : 'bck')}
                    <SnakeBlock info={direction !== 'fwd' ? head : tail} showGoBack={() => setShowGoBack(-1)}/>
                </div>
            </div>
            {gameStatus === 'in progress' ?
                <div style={{width:'100%', marginBottom: 10, }}>
                    <SearchBar select={(suggestion) => check(suggestion)} type={currentSearchType()}  guessStatus={guessStatus} flip={flip} usedIds={usedIds} triggerHint={triggerHint}/>
                </div>
            
            :
                <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', width:'100%', height: 100}}/>
            }
        </div>
    )
}


export default WebGameContainer
